module.exports = __webpack_public_path__ + "media/ChenXueRan-WuMingZhiBei.70665472.mp3";